
<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.exportToAudanet' | translate}}
</kendo-dialog-titlebar>

<div *ngIf="!isLoading && !selectedTaskId && claimIdentifier" flex="98" fxLayout="column" fxLayoutAlign="center start">
    <h2> {{'claims-center.claimDocumentation.step1ChooseAudanetTask' | translate}}</h2>
    <button fxFlex="60" kendoButton (click)="selectAudanetTask()"
        [primary]="true" type="button">
        <span>{{'claims-center.claimDocumentation.selectAudanetTask' | translate}}</span>
    </button>
</div>

<div *ngIf="selectedTaskId" fxLayoutGap="10px" fxLayout="column" fxLayoutAlign="start start">
    <h4>{{'claims-center.audanetIntegration.assignedToAudanetTask' | translate}}</h4>
    <div fxLayout="row" fxLayoutGap="10px">
        <div fxLayout="column wrap" fxFlex="48">
            <div>{{'claims-center.audanetIntegration.brandModel' | translate}} :
                <strong>{{selectedTaskInfo.carBrand}} {{
                    selectedTaskInfo.carModel}}</strong>
            </div>
            <div>{{'claims-center.audanetIntegration.plateNumber' | translate}} :
                <strong>{{selectedTaskInfo.plateNumber}}</strong>
            </div>
            <div>{{'claims-center.audanetIntegration.vin' | translate}} : <strong>{{selectedTaskInfo.vin}}</strong>
            </div>
            <div>{{'claims-center.audanetIntegration.status' | translate}} :
                <strong>{{selectedTaskInfo.taskStatus}}</strong>
            </div>
        </div>
        <div fxLayout="column wrap" fxFlex="48">
            <div>{{'claims-center.audanetIntegration.creationDate' | translate}} :
                <strong>{{selectedTaskInfo.creationDate | date:'yyyy-MM-dd HH:mm' }}</strong>
            </div>
            <div>{{'claims-center.audanetIntegration.lastEditedDateTime' | translate}} :
                <strong>{{selectedTaskInfo.lastEditedDateTime | date:'yyyy-MM-dd HH:mm'}}</strong>
            </div>

            <div *ngIf="selectedTaskData?.insuranceCompanyName">
                {{'claims-center.audanetIntegration.insuranceCompany' | translate}} :
                <strong>{{selectedTaskData.insuranceCompanyName}}</strong>
            </div>
            <div *ngIf="selectedTaskData?.repairerName">{{'claims-center.audanetIntegration.repairer' | translate}}
                : <strong>{{selectedTaskData.repairerName}}</strong>
            </div>
        </div>
    </div>
</div>

<div fxLayout="column" fxLayoutGap="15px">

    <div *ngIf="audanetTaskAttachments.length > 0">

        <h4>{{'claims-center.audanetIntegration.belowFilesWillBeSentToAudanetPlatform' | translate}}</h4>
        <kendo-grid [data]="audanetTaskAttachments" [size]="'small'">

            <kendo-grid-column field="fileName" title="{{'claims-center.claimDocumentation.fileName' | translate}}"
                [width]="200">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    {{document.fileName}}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="documentKind"
                title="{{'claims-center.claimDocumentation.documentKind' | translate}}" [width]="200">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    <div fxLayout="column">
                        {{ document.documentKindId | staticDictionaryCaption:'documentKind' | async }}
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="audanetCategoryId"
                title="{{'claims-center.claimDocumentation.audanetCategoryId' | translate}}" [width]="100">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    {{document.audanetCategoryId}}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="audanetCategoryName"
                title="{{'claims-center.claimDocumentation.audanetCategoryName' | translate}}" [width]="100">
                <ng-template kendoGridCellTemplate let-document="dataItem">
                    {{document.audanetCategoryName}}
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="audanetCategoryName"
            title="" [width]="30">
            <ng-template kendoGridCellTemplate let-document="dataItem">
                <kendo-icon *ngIf="document.transferToAudanetResult" [name]="'check-circle'" [themeColor]="'success'"></kendo-icon>
            </ng-template>
        </kendo-grid-column>

        </kendo-grid>
    </div>

    <div *ngIf="!claimIdentifier">
        <strong class="error-label">{{'claims-center.audanetIntegration.cantExportToAudanetDocsNotAssociatedToClaim' |
            translate}}</strong>
    </div>

    <div *ngIf="exportDocumentItemsWithoutMappings?.length > 0" fxLayout="column">
        <strong class="error-label">{{'claims-center.audanetIntegration.documentWontBeSentAsThereisNoMappingToAudanet' | translate}} :
            </strong>
        <div *ngFor="let notMappedItem of exportDocumentItemsWithoutMappings">
            <span>{{notMappedItem.targetFileName}} -  {{ notMappedItem.documentKindId | staticDictionaryCaption:'documentKind' | async }}</span>
        </div>
    </div>

    <app-loading-panel [isLoading]="isLoading" [size]="'medium'"></app-loading-panel>

 
</div>

<div kendoDialogContainer #audanetExportDocumentDialog></div>

<kendo-dialog-actions>
    <button *ngIf="selectedTaskId && !isLoading && audanetTaskAttachments.length"  
            kendoButton (click)="exportToAudanet()" [primary]="true" type="button">
        <span>{{'claims-center.claimDocumentation.exportToAudanet' | translate}}</span>
    </button>
</kendo-dialog-actions> 
